// extracted by mini-css-extract-plugin
export default {"npiField":"NpiField_npiField__goV08"};